export function chequeFileNameFromPath(fullPath: string): string {
  const normalized = fullPath.replace(/\\/g, "/");
  const seg = normalized.split("/").filter(Boolean);
  return seg.length > 0 ? seg[seg.length - 1]! : "Cancelled cheque";
}
